<template>
  <div class="blog-post-page">
    <section class="blog-post-profile">
      <div class="container px-3">
        <div class="loader" v-if="isLoading">
          <beat-loader :loading="true" :color="'#2424FC'"></beat-loader>
        </div>
        <div v-if="post" class="content">
          <div class="title !p-0 px-3 lg:mx-32">
            <h1 class="h1 !p-0">{{ post.attributes.title }}</h1>
          </div>

          <div class="mt-2 text-center">
            {{ new Date(post.attributes.createdAt).toLocaleDateString() }}
          </div>

          <div class="flex justify-center mt-4 gap-2">
            <router-link
              :to="{
                path: `/blog/tag/${tag.attributes.slug}`,
                hash: 'enter',
              }"
              class="p-1 blue rounded-md text-white no-underline"
              v-for="tag in post.attributes.tags.data"
              :key="tag.attributes.slug"
            >
              {{ tag.attributes.name }}
            </router-link>
          </div>

          <div class="flex items-center gap-1 mt-8">
            <router-link
              class="flex gap-1 no-underline breadcrumb"
              :to="{
                path: `/`,
                hash: 'enter',
              }"
            >
              <div>Fooldal</div>
              <div>
                <ArrowRight />
              </div>
            </router-link>
            <router-link
              class="flex gap-1 no-underline breadcrumb"
              :to="{
                path: `/blog`,
                hash: 'enter',
              }"
            >
              <div class="hover:text-red">Blog</div>
              <div>
                <ArrowRight />
              </div>
            </router-link>
            <div class="hidden md:flex">{{ post.attributes.title }}</div>
          </div>

          <img
            :src="imageUrl"
            :alt="post.attributes.title"
            class="max-h-80 rounded-md mt-1 object-cover"
          />

          <div class="mx-0 lg:mx-16">
            <p class="font-bold text-base mb-6">
              {{ post.attributes.excerpt }}
            </p>
            <hr class="mb-6 mx-16" />
            <article class="article-content" v-html="content"></article>
            <div class="flex items-center gap-1 mt-8">
              <a
                target="_blank"
                :href="
                  `http://www.facebook.com/share.php?u=${shareUrl}&utm_medium=social&utm_source=facebook`
                "
                ><Facebook class=""
              /></a>
              <a
                target="_blank"
                :href="
                  `https://www.linkedin.com/shareArticle/?mini=true&url=${shareUrl}&utm_medium=social&utm_source=linkedin`
                "
                ><LinkedIn
              /></a>
              <a
                target="_blank"
                :href="
                  `https://twitter.com/intent/tweet?original_referer=${shareUrl}&utm_medium=social&utm_source=twitter&url=${shareUrl}&utm_medium=social&utm_source=twitter&source=tweetbutton&text=${encodeURIComponent(
                    post.attributes.title
                  )}`
                "
                ><Twitter
              /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import axios from "axios";
  import qs from "qs";
  import BeatLoader from "vue-spinner/src/PulseLoader.vue";
  import ArrowRight from "@/components/icons/ArrowRight";
  import Facebook from "@/components/icons/Facebook";
  import LinkedIn from "@/components/icons/LinkedIn";
  import Twitter from "@/components/icons/Twitter";

  export default {
    name: "Blog",
    components: {
      BeatLoader,
      ArrowRight,
      Facebook,
      LinkedIn,
      Twitter,
    },
    metaInfo() {
      return {
        title: this.post?.attributes?.title,
        meta: [
          { name: "description", content: this.post?.attributes?.excerpt },
          { name: "og:title", content: this.post?.attributes?.title },
          { name: "og:description", content: this.post?.attributes?.excerpt },
          {
            name: "og:image",
            content: `${process.env.VUE_APP_API_URL}${this.post?.attributes
              ?.coverImage?.data?.attributes.formats?.small?.url ||
              this.post?.attributes?.coverImage?.data?.attributes?.url}`,
          },
        ],
      };
    },
    data() {
      return {
        post: null,
        isLoading: true,
      };
    },
    methods: {},
    computed: {
      imageUrl() {
        return `${process.env.VUE_APP_API_URL}${this.post.attributes.coverImage.data.attributes.url}`;
      },
      content() {
        return this.post.attributes.content.replaceAll(
          "/uploads",
          `${process.env.VUE_APP_API_URL}/uploads`
        );
      },
      shareUrl() {
        return `${window.location.host}${encodeURIComponent(this.$route.path)}`;
      },
    },
    async mounted() {
      const query = {
        filters: { slug: { $eq: this.$route.params.slug } },
        populate: ["coverImage", "tags"],
        pagination: {
          limit: 1,
          start: 0,
        },
      };
      try {
        const posts = await axios.get(`blog-posts?${qs.stringify(query)}`);
        this.post = posts.data.data[0];
        if (!this.post) {
          this.$router.push("/not-found");
        }
        // console.log(this.post.attributes.tags.data);
        this.isLoading = false;
      } catch (e) {
        // console.log(e);
      }
    },
  };
</script>

<style lang="scss">
  .blue {
    background-color: #2424fc;
  }
  .blog-post-page {
    background: $white;
    display: flex;
    flex-direction: column;

    .fullscreen {
      position: fixed;
      left: 0;
      top: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $black;
      opacity: 0;
      transition: all 0.3s ease-in-out;
      &.opened {
        z-index: 1000;
        opacity: 1;
      }
      picture {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .blog-post-profile {
    padding: 0 0 54px !important;
    background: $background;
    display: block;
    width: 100%;

    .container {
      .loader {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .content {
        display: flex;
        flex-direction: column;

        hr {
          border-top: 1px solid rgb(87, 91, 108);
        }

        .article-content {
          img {
            height: auto;
            width: 100%;
            border-radius: 0.375rem;
          }
          span {
            color: rgb(87, 91, 108) !important;
          }
        }

        .breadcrumb {
          color: rgba(42, 46, 71, 0.547);
          &:hover {
            color: rgb(87, 91, 108);
          }
        }

        .head {
          padding: 0 16px;
          margin-bottom: 24px;
        }
        .title {
          padding: 0 16px;
          margin-bottom: 12px;
          .h1 {
            text-align: center;
            font-size: 38px;
            line-height: 40px;
            font-weight: 500;
          }
        }
        .text {
          padding: 0 16px;
          .h3 {
            margin-bottom: 8px;
          }
          p {
            margin: 0 0 24px 0;
          }
        }
      }
    }
    @media screen and (min-width: 550px) {
    }
    @media screen and (min-width: $breakpoint) {
      margin: 0;
      padding: 40px 0 168px 0 !important;
      .container {
        position: relative;

        .content {
          position: relative;
          z-index: 10;
          // margin-top: -240px;
          // padding-top: 240px;
          display: flex;
          //height: 800px;
          justify-content: flex-start;
          flex-wrap: wrap;
          flex-direction: column;
          .head {
            padding: 0 100px 0 0;
            .button {
              display: inline-flex;
            }
          }
          .title {
            //width: 60%;
            box-sizing: border-box;
            // padding: 0 100px 0 0;
            //margin-bottom: 16px;
            .h1 {
              margin-top: 40px;
              font-size: 54px;
              line-height: 60px;
              font-weight: 500;
            }
          }

          .text {
            //width: 60%;
            box-sizing: border-box;
            padding: 0 100px 0 0;
            margin-bottom: 24px;
            p {
              margin: 0 0 16px 0;
            }
          }
        }
      }
    }
  }
</style>
